import React from "react";
import { FastField, useFormikContext } from "formik";
import { Row, Col, Form } from "react-bootstrap";
import { MecordColors } from "Constants/Color";
import { QuotationFormValues } from "../initialValues";
import { ServiceQuotationFormValues } from "../serviceInitialValues";
import { parse, format } from "date-fns";

const FollowUpSection: React.FC = () => {
  const { errors, touched, values } = useFormikContext<QuotationFormValues | ServiceQuotationFormValues>();

  // Convert quotation_date from dd-MMM-yyyy to YYYY-MM-DD for min attribute
  const getMinDate = (): string => {
    if (!values.quotation_date) return "";
    try {
      // Parse dd-MMM-yyyy format
      const parsed = parse(values.quotation_date, "dd-MMM-yyyy", new Date());
      if (isNaN(parsed.getTime())) return "";
      // Return in YYYY-MM-DD format for date input
      return format(parsed, "yyyy-MM-dd");
    } catch {
      return "";
    }
  };

  const minDate = getMinDate();
  return (
    <div className="rounded">
      <div className="d-flex justify-content-between align-items-center gap-2">
        <h5 className="fw-semibold">Schedule Follow-up</h5>
      </div>
      <div
        className="rounded p-2 pt-3"
        style={{ backgroundColor: MecordColors?.LightGrayColor }}
      >
        <Row className="g-3">
          <Col md={12}>
            <Form.Group>
              <Form.Label>
                Next Follow Up Date<span className="text-danger">*</span>
              </Form.Label>
              <FastField name="next_follow_up_date">
                {({ field }: any) => (
                  <Form.Control
                    {...field}
                    type="date"
                    placeholder="Select Follow Up Date"
                    min={minDate}
                    onInvalid={(e: any) => {
                      if (minDate && e.target.value && new Date(e.target.value) < new Date(minDate)) {
                        e.target.setCustomValidity(`Follow up date cannot be before quotation date (${values.quotation_date})`);
                      } else {
                        e.target.setCustomValidity("");
                      }
                    }}
                    onInput={(e: any) => {
                      e.target.setCustomValidity("");
                    }}
                  />
                )}
              </FastField>
              {errors.next_follow_up_date && touched.next_follow_up_date && (
                <div className="invalid-feedback d-block">{errors.next_follow_up_date as string}</div>
              )}
            </Form.Group>
          </Col>
          <Col md={12}>
            <Form.Group>
              <Form.Label>Remarks</Form.Label>
              <FastField name="follow_up_remarks">
                {({ field }: any) => (
                  <Form.Control
                    {...field}
                    as="textarea"
                    rows={3}
                    style={{ maxHeight: '400px', resize: 'vertical' }}
                    placeholder="Enter remarks"
                  />
                )}
              </FastField>
            </Form.Group>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default FollowUpSection;

